module.exports = __webpack_public_path__ + "img/37.112f008a.jpg";